import { DobInput } from '@dedalusdiit/dob-components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Styles from './HeaderSearch.module.scss';
import { useNavigate } from 'react-router';

const {
    search: searchStyle,
} = Styles;

export const HeaderSearch = (): React.ReactElement => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState<string>('');

    const doSearch = async (): Promise<void> => {
        if (searchTerm === '') {
            return;
        }
        await navigate(`GeneralSearch/${searchTerm.replaceAll('/', '-')}`);
        setSearchTerm('');
    };

    const onKeyDownHandler = (e: React.KeyboardEvent<HTMLInputElement>): void => {
        if (e.key === 'Enter') {
            doSearch()
                .catch((err) => {
                    console.error('Error during navigation to search results', err);
                });
        }
    };

    const searchPlaceholderText = `${t('GeneralSearch')} ${t('on')} ${t('OrderNumber')} ${t('or')} ${t('DOB')} ${t('or')} ${t('PatientName')}`;

    return (
        <DobInput
            placeholder={searchPlaceholderText}
            icon="search"
            value={searchTerm}
            className={searchStyle}
            onValueChange={(val) => setSearchTerm(val)}
            onKeyDown={onKeyDownHandler}
        />
    );
};
